// extracted by mini-css-extract-plugin
export default {"qrCard":"qrCard_fTbcf","img":"img_ABhIZ"};